import React from "react";
import { useNavigate } from "react-router-dom";
import "./work.css";
import Works from "./Works";

const Work = () => {
  const isAuthenticated = !!localStorage.getItem("accessToken");

  const navigate = useNavigate();

  const handleEdit = () => {
    navigate("/work/edit");
  };

  return (
    <section className="work section" id="portfolio">
      <h2 className="section__title">Portfolio</h2>
      <span className="section__subtitle">Demo Projects</span>
      {isAuthenticated && (
        <button className="work__edit-btn" onClick={handleEdit}>
          Edit
        </button>
      )}
      <Works />
    </section>
  );
};

export default Work;
